import Plans from "../../components/Plans"

const Premium = ({ container }) => {

    return <Plans container={container}></Plans>
}

export default Premium;